import { DropdownOptions } from "interfaces";

// TODO(BASH-3843): replace with the exact Type of Loss values NGLS sends.
// These are the values the form used before the change.
const lossTypes = [
  "Animal/Pest Damage",
  "Earthquake",
  "Fire",
  "Flood",
  "FEMA Structure Elevation",
  "Flood w/ Mold",
  "Hail",
  "Homicide/Suicide",
  "Hurricane",
  "Ice Damage",
  "Landslide/Mudslide",
  "Lightning",
  "Mold",
  "Puff Back (chimney soot)",
  "Sewage/Septic Tank",
  "Smoke Damage",
  "Sink Hole",
  "Tornado",
  "Tree Damage",
  "Tropical Storm",
  "Unknown",
  "Vandalism/Malicious Mischief",
  "Vehicular Damage",
  "Water Damage",
  "Wind w/ Hail",
  "Wind",
  "Windstorm",
  "Water Damage w/Mold",
];

export const lossTypeOptions: DropdownOptions[] = lossTypes.map((type) => ({
  value: type,
  label: type,
}));

// TODO(BASH-3843): replace with the NGLS label for the borrower section.
export const LOSS_DRAFT_YOUR_INFO_LABEL = "Your Info";

// TODO(BASH-3843): replace with the NGLS helper text. Empty shows no helper text.
export const LOSS_DRAFT_ADDRESS_HELPER_TEXT = "";
